import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-column-sort',
  template: `
    <span (click)="onSort()" style="cursor: pointer">{{ label }}</span>
    <i *ngIf="value == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
    <i *ngIf="value == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
  `
})
export class ColumnSortComponent {
  @Input()
  public label: string;
  @Input()
  public value: string;

  @Output() change = new EventEmitter<string>();

  onSort() {
    if (!this.value) {
      this.value = 'DESC';
    } else if (this.value == 'DESC') {
      this.value = 'ASC';
    } else if (this.value == 'ASC') {
      this.value = null;
    }

    this.change.emit(this.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/column-sort/column-sort.component.ts